import React, { Component } from 'react'
import { graphql, compose } from 'react-apollo'
import { translate } from 'react-i18next'
import { withRouter } from 'react-router-dom'

import { Loader, Form, TextAreaInput } from '../../../UI'
import { validateRequired } from '../../../../libs/validation'
import UPDATE_LOCAL_TOUR from '../../../../graphql/ActivitySteps/UpdateLocalTourWhereWeBe.graphql'
import { NotificationManager } from 'react-notifications';

class WhereWillBe extends Component {
  state = {
    saving: false
  }

  componentDidMount() {
    this.setState({
      whereWeBe: this.props.currentSteps.whereWeBe || ''
    })
  }

  handleSubmit = values => {
    const { data, updateLocalTour, updateSteps, history } = this.props

    this.setState({
      saving: true
    })

    updateLocalTour({
      variables: {
        id: this.props.currentSteps.id,
        whereWeBe: values.whereWeBe
      }
    }).then(() => {
      updateSteps()

      this.setState(
        {
          saving: false
        },
        () => {
          NotificationManager.success('Where we will be updated', 'Success', 5000)
          if (data.allLocalTours && data.allLocalTours[0]) {
            history.push(`/activity-steps/${data.allLocalTours[0].id}/what-you-provide`)
          } else {
            history.push('/activity-steps/what-you-provide')
          }
        }
      )
    }).catch(err=>NotificationManager.error('Error while updating where will be', 'Error', 5000))
  }

  render() {
    const { t, loading } = this.props
    const { saving, whereWeBe } = this.state

    if (loading) {
      return <Loader showLoader={true} />
    }

    return (
      <div className="steps-screen__form step-form faded-container">
        <div className="steps-screen__form-title">{t('where_will_be')}</div>
        <Form
          onSubmit={this.handleSubmit}
          submitBtnClassname="btn btn-lg btn-primary btn-danger steps-submit-btn"
          submitBtnName={t('main:save_continue')}
          submittingToServer={saving}
        >
          <div className="steps-screen__form-input-area">
            <label className="steps-screen__form-input-label">{t('where_description')}</label>

            <TextAreaInput
              id="whereWeBe"
              placeholder={''}
              initialValue={whereWeBe}
              maxChars={800}
              validationFuncs={[validateRequired]}
              labelClass="steps-screen__form-input-label"
            />
          </div>
        </Form>
      </div>
    )
  }
}

const enhance = compose(
  translate('activity_steps'),
  graphql(UPDATE_LOCAL_TOUR, {
    name: 'updateLocalTour'
  }),
  withRouter
)

export default enhance(WhereWillBe)



// WEBPACK FOOTER //
// src/components/ActivitySteps/Steps/MoreDetails/WhereWillBe.jsx